import { UNLIMITED_TIER } from "@chesshotel/constants";
import { useUser } from "../../../redux/user";
import { useMembership } from "../../../redux/membership";
import { useLeagues } from "../../../redux/leagues";
import { useLobby } from "../../../redux/lobby";
// import { INITIAL_LEAGUE_GAMES } from "@chesshotel/constants";
import dynamic from "next/dynamic";
import { useSignIn } from "@/redux/signIn";
import { useMetrica } from "@/lib/next-yandex-metrica";
import { useEffect } from "react";
const SeasonPopup = dynamic(() => import("./SeasonPopup"));
const LeagueGamePopup = dynamic(() => import("./LeagueGamePopup"));
const LeagueGameGuestPopup = dynamic(() => import("./LeagueGameGuestPopup"));
// const NotActivatedPopup = dynamic(() => import("./NotActivatedPopup"));
const FBUpgradePopup = dynamic(() => import("./FBUpgradePopup"));

export default function LobbyPopups() {
  // const [didShow, setDidShow] = useState(false);
  const { fbNeedsUpgrade } = useSignIn();
  const { isGuest, emailNotActivated } = useUser();
  const { tier, leagueGames } = useMembership();
  const { didViewSeasonPopup, hasLastSeason } = useLeagues();
  const { leaguePlay } = useLobby();

  const showSeasonPopup = hasLastSeason && !didViewSeasonPopup;
  const showLeagueGameGuestPopup = leaguePlay && isGuest && leagueGames <= 0;
  const showLeagueGamePopup =
    !isGuest && leaguePlay && leagueGames <= 0 && tier !== UNLIMITED_TIER;

  const { reachGoal } = useMetrica();

  useEffect(() => {
    if (showLeagueGameGuestPopup) {
      reachGoal("signup_start_outofleaguegames_popup");
    }
    if (showLeagueGamePopup) {
      reachGoal("membership_start_lobby_leaguegames");
    }
  }, [showLeagueGameGuestPopup, showLeagueGamePopup, reachGoal]);
  return (
    <>
      {showSeasonPopup && <SeasonPopup />}
      {showLeagueGameGuestPopup && <LeagueGameGuestPopup />}
      {showLeagueGamePopup && <LeagueGamePopup />}
      {/* {!isGuest &&
        leaguePlay &&
        emailNotActivated &&
        leagueGames <= INITIAL_LEAGUE_GAMES - 11 && <NotActivatedPopup />} */}
      {fbNeedsUpgrade && <FBUpgradePopup />}
    </>
  );
}
